// Off until the key and endpoint are set at build time; the browser UUID in lib/deviceId stays either way.
const PUBLIC_KEY = process.env.REACT_APP_FINGERPRINT_PUBLIC_KEY as string | undefined;
const ENDPOINT = process.env.REACT_APP_FINGERPRINT_ENDPOINT as string | undefined;
const REGION = (process.env.REACT_APP_FINGERPRINT_REGION as string | undefined) || "us";
// Long enough for a first load (the script alone can take 3s); ad blockers fail at once, not here.
const TIMEOUT_MS = 6000;

interface FingerprintAgent {
  get: () => Promise<{ event_id: string }>;
}

interface FingerprintModule {
  start: (options: { endpoints: string[]; region: string }) => FingerprintAgent;
}

let agent: Promise<FingerprintAgent> | null = null;

const loadAgent = (): Promise<FingerprintAgent> => {
  agent ??= import(/* @vite-ignore */ `${ENDPOINT}/web/v4/${PUBLIC_KEY}`)
    .then((module: FingerprintModule) =>
      module.start({ endpoints: [ENDPOINT as string], region: REGION }),
    )
    .catch((error: unknown) => {
      agent = null;
      throw error;
    });
  return agent;
};

// Loads the agent ahead of sign-in, without the billed get(): a Telegram or wallet return has no time to spare.
export const preloadDeviceProof = (): void => {
  if (PUBLIC_KEY && ENDPOINT) loadAgent().catch(() => undefined);
};

// The event id the server checks with Fingerprint. Empty on any failure: sign-in carries on.
export const getDeviceProof = async (): Promise<string> => {
  if (!PUBLIC_KEY || !ENDPOINT) return "";
  try {
    const timeout = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error("timeout")), TIMEOUT_MS),
    );
    const result = await Promise.race([loadAgent().then((loaded) => loaded.get()), timeout]);
    return result.event_id;
  } catch {
    // A timeout keeps the agent: it is still loading, and the next sign-in can use it.
    return "";
  }
};
